import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateComponent } from '../state-component.interface';
import { Subscription } from 'rxjs';
import { Usdm2Service } from '../../../../services/ai/usdm2.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

type Duration = {
  duration_value: number;
  duration_unit_code: { uid: string; name: string };
};
type PopulationInput = {
  rare_disease_indicator: boolean;
  healthy_subject_indicator: boolean;
  planned_minimum_age_of_subjects: Duration;
  // Backend sends null when the protocol states no limit / no duration.
  planned_maximum_age_of_subjects: Duration | null;
  stable_disease_minimum_duration: Duration | null;
  pediatric_study_indicator: boolean;
  pediatric_postmarket_study_indicator: boolean;
  pediatric_investigation_plan_indicator: boolean;
  relapse_criteria: string;
  relapse_criteria_null_value_code: string;
  number_of_expected_subjects: number;
  sex_of_participants_code: string;
  disease_condition_or_indication_codes: string[];
  therapeutic_area_codes: string[];
};

@Component({
  selector: 'app-population',
  imports: [],
  templateUrl: './population.component.html',
  styleUrl: './population.component.css',
})
export class PopulationComponent implements StateComponent, OnInit, OnDestroy {
  stateName: string = 'Population';
  private usdmSub: Subscription | null = null;
  sexCode: string = '';
  therapeuticArea: string = '';
  diseaseCondition: string = '';
  data: PopulationInput | null = null;

  constructor(
    private usdm: Usdm2Service,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.usdmSub = this.usdm.contentUpdate$.subscribe((item) => {
      if (this.usdm.currentState() == this.stateName && item && item.type === 'FinishResponse') {
        this.data = item.result as PopulationInput;
        this.extractPopulation();
        this.usdm.signalStateCompletion(this.stateName);
      }
    });
  }

  ngOnDestroy(): void {
    this.usdmSub?.unsubscribe();
    this.usdmSub = null;
  }

  duration(d: Duration | null | undefined): string {
    return d ? `${d.duration_value} ${d.duration_unit_code?.name ?? ''}`.trim() : 'Not specified';
  }

  extractPopulation(): void {
    if (!this.data) {
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.http.get(`${environment.osburl}/api/ct/terms/names?page_size=100&codelist_uid=C66732`, {}).subscribe((response: any) => {
      if (response) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.sexCode = response.items.find((item: any) => item.term_uid === this.data?.sex_of_participants_code)?.sponsor_preferred_name || '';
      }
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.http.get(`${environment.osburl}/api/dictionaries/terms?codelist_uid=DictionaryCodelist_000001&page_size=0&sort_by=%7B%22name%22:true%7D`, {}).subscribe((response: any) => {
      if (response) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.therapeuticArea = response.items.find((item: any) => item.term_uid === this.data?.therapeutic_area_codes?.[0])?.name || '';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.diseaseCondition = response.items.find((item: any) => item.term_uid === this.data?.disease_condition_or_indication_codes?.[0])?.name || '';
      }
    });
  }
}
